<template>
    <div></div>
</template>

<script>
export default {
    props: {
        status: String,
        message: String,
    },

    created() {
        if (!this.message) {
            return
        }

        this.$swal({
            icon: this.status || 'success',
            text: this.message,
            timer: 3000,
        })
    },
}
</script>
